module.exports = __webpack_public_path__ + "static/media/News1.7d80a35b.png";